import { type AnalyticsEventPayload, type UIAnalyticsEvent } from '@atlaskit/analytics-next';

type ErrorDetails = {
	message: string;
	stack?: string;
};
export type AnalyticsAttributes = Record<
	string,
	string | number | boolean | ErrorDetails | undefined | object
>;

interface FireAnalyticsProps {
	analyticsEventFireName: string;
	bridge: string;
	actionSubjectId: string; //
	createAnalyticsEvent: (payload: AnalyticsEventPayload) => UIAnalyticsEvent;
	destinationApp: string;
	source: string;
	tags: string[];
}

// An analytic to track custom cross app experiences (embedded, side-by-side, or a hand-off)
// This is needed as the useCrossProductUrlWrapper does not work with custom experiences
export const fireCustomCrossAppAnalytic = ({
	tags,
	destinationApp,
	createAnalyticsEvent,
	analyticsEventFireName,
	bridge,
	source,
	actionSubjectId,
}: FireAnalyticsProps): void => {
	const analyticsEvent = createAnalyticsEvent({
		action: 'customCrossAppExperience',
		actionSubject: 'viewed',
		actionSubjectId,
		eventType: 'ui',
		tags,
		attributes: {
			bridge,
			source,
			destinationApp,
		},
	});

	analyticsEvent.fire(analyticsEventFireName);
};
